// Tiny helper to pick openId from react-router location.state or query and expose to StorePayments
export function getOpenIdFromLocation(location) {
  try {
    const st = location?.state;
    if (st && typeof st === 'object' && st.openId) return String(st.openId);
  } catch {}
  try {
    const params = new URLSearchParams(location?.search || "");
    const q = params.get("open");
    if (q) return String(q);
  } catch {}
  return null;
}
